import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { trimTrailingZeros } from '../../../utils/_helpers';


const borderColor = "#263238";
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: borderColor,
        alignItems: 'center',
        fontStyle: 'bold',
        paddingRight: 8,
        paddingLeft: 8,
    },
    description: {
        width: '30%',
        textAlign: 'center',
        borderRightColor: borderColor,
        borderLeftColor: borderColor,
        borderLefttWidth: 1,
        borderRightWidth: 1,
        fontSize:8.5,
        borderBottomWidth: 1,
        
    },
    qty: {
        width: '7%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'center',
        fontSize:8.5,
        borderBottomWidth: 1,
    },
    UM: {
        width: '7%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'center',
        fontSize:8.5,
        borderBottomWidth: 1,
    },
    rate: {
        width: '13%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        textAlign: 'center',
        fontSize:8.5,
        borderBottomWidth: 1,
    },
    SKU:{
        width: '15%',
        borderLeftColor: borderColor,
        borderRightColor: borderColor,
        borderRightWidth: 1,
        borderLeftWidth: 1,
        textAlign: 'center',
        fontSize:8.5,
        borderBottomWidth: 1,

    },
    CLIN:{
        width: '13%',
        borderLeftColor: borderColor,
        borderRightColor: borderColor,
        borderRightWidth: 1,
        borderLeftWidth: 1,
        textAlign: 'center',
        fontSize:8.5,
        borderBottomWidth: 1,

    },
    SNo:{
        width: '5%',
        borderRightColor: borderColor,
        borderLeftColor: borderColor,
        borderLeftWidth: 1,
        textAlign: 'center',
        fontSize:8.5,
        borderBottomWidth: 1,
    },
    amount: {
        width: '15%',
        textAlign: 'center',
        fontSize:8.5,
        borderRightWidth: 1,
        borderBottomWidth: 1,
    },
});

const InvoiceTableRow = ({ invoice }) => {
    const rows = invoice.items?.map((item,index) =>
    <>
        <View style={styles.CLIN} wrap={false}><Text>{item.clin_id ?? (index + 1).toLocaleString()}</Text></View>
    {/* <View style={styles.SNo} wrap={false}><Text>{(index + 1).toLocaleString()}</Text></View> */}
    <View style={styles.SKU} wrap={false}><Text>{item.sku_display_name}</Text></View>
    <View style={styles.description} wrap={false}><Text>{item.description ?? ''}</Text></View>
    <View style={styles.qty} wrap={false}><Text>{trimTrailingZeros(item.quantity) ?? ''}</Text></View>
    <View style={styles.UM} wrap={false}> <Text>{item.unit_of_measure ?? ''}</Text></View>
    <View style={styles.rate} wrap={false}>
        {/* <Text>{'$ ' + Number(item.customer_price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Text> */}
           <Text>
          {item.customer_price != null
            ? '$ ' +
              Number(item.customer_price).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : ''}
        </Text>
      </View>
    <View style={styles.amount} wrap={false}>
        {/* <Text>{'$ ' + Number(item.quantity * item.customer_price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Text> */}

           <Text>
          {item.quantity != null && item.customer_price != null
            ? '$ ' +
              Number(item.quantity * item.customer_price).toLocaleString(
                'en-US',
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )
            : ''}
        </Text>
        </View>
</>
    );
    return (<Fragment>{rows}</Fragment>)
};

export default InvoiceTableRow;